import datalayer from '../helpers/datalayer'

class NavProduct {
  constructor (el) {
    this.link = el
    this.productHandle = this.link.href.split('/products/')[1]

    this.init()
  }

  init () {
    // there will only ever be one link in each atom
    this.link.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.productHandle) {
        return new Promise((resolve, reject) => {
          datalayer.getProductByHandle(this.productHandle)
            .then((response) => {
              // console.log('Nav product click data response:', response)
              return response
            })
            .then((data) => {
              // console.log('Nav product click data resolve:', data)

              datalayer.pushProductClickEvent(data, this.link.dataset.productList, this.link.dataset.productPosition, this.link.href)

              resolve()
            })
            .catch((err) => {
              console.error('Nav product click error:', err)

              reject(err)
            })
        })
      }
    })
  }
}

window.addEventListener('load', () => {
  document
    .querySelectorAll('[data-a-nav-product]')
    .forEach(el => new NavProduct(el))
})
